export const coords = {
  BDtoGD: function (bdLat, bdLng) { // 百度坐标转高德（传入经度、纬度）
    var X_PI = Math.PI * 3000.0 / 180.0
    var x = bdLng - 0.0065
    var y = bdLat - 0.006
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI)
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI)
    var ggLng = z * Math.cos(theta)
    var ggLat = z * Math.sin(theta)
    return [ggLat, ggLng]
  },
  GDtoBD: function (ggLat, ggLng) { // 高德坐标转百度（传入经度、纬度）
    var X_PI = Math.PI * 3000.0 / 180.0
    var x = ggLng
    var y = ggLat
    var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI)
    var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI)
    var bdLng = z * Math.cos(theta) + 0.0065
    var bdLat = z * Math.sin(theta) + 0.006
    return [bdLat, bdLng]
  },
  TXtoBD: function (lat, lng) {
    if (lng == null || lng == '' || lat == null || lat == '')
      return [lng, lat];
    var x_pi = 3.14159265358979324;
    var x = parseFloat(lng);
    var y = parseFloat(lat);
    var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
    var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
    var lng = (z * Math.cos(theta) + 0.0065).toFixed(5);
    var lat = (z * Math.sin(theta) + 0.006).toFixed(5);
    return [lat, lng];
  }
}

export default coords